import { useHover } from 'react-use';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const transitionClasses = 'transition-all duration-150';

interface AnimatedCircleProps {
  hovered: boolean;
  icon: React.ReactNode;
  label: string;
}

function AnimatedCircle({ hovered, icon, label }: AnimatedCircleProps) {
  return (
    <div
      className={`relative ${
        hovered ? 'w-24 h-24' : 'w-20 h-20'
      } ${transitionClasses}`}
    >
      <div
        className={classNames(
          'absolute flex justify-center items-center w-full h-full text-5xl',
          !hovered && 'text-gray-400',
          hovered && 'text-secondary'
        )}
      >
        {icon}
      </div>
      <div
        className={`absolute w-full h-full rounded-full ${
          hovered
            ? 'border-4 border-primary translate-x-1.5'
            : 'border-4 border-gray-400'
        } ${transitionClasses}`}
      ></div>
      <div
        className={`absolute w-full h-full rounded-full border-4 ${
          hovered ? 'border-secondary -translate-x-1.5' : 'border-gray-400'
        } ${transitionClasses}`}
      ></div>
    </div>
  );
}

type NavCardProps = {
  label: string;
  description: string;
  to: string;
  icon: React.ReactNode;
};

export default function NavCard({
  label,
  description,
  to,
  icon,
}: NavCardProps) {
  const element = (hovered) => (
    <Link
      className={`group w-80 flex flex-col cursor-pointer filter hover:drop-shadow-2xl ${transitionClasses}`}
      to={to || ''}
    >
      <div
        className={`flex flex-col flex-grow rounded-t-half bg-gray-100 h-96 group-hover:bg-white ${transitionClasses}`}
      >
        <div className="flex flex-1 justify-center items-center">
          <AnimatedCircle hovered={hovered} label={label} icon={icon} />
        </div>
        <div className="flex flex-col flex-1 justify-center items-center">
          <h4 className={`${hovered && 'text-3xl'} ${transitionClasses}`}>
            {label}
          </h4>
          <p className="text-center px-8">{description}</p>
        </div>
      </div>
      <div
        className={`flex justify-center items-center h-24 rounded-b-half bg-primary group-hover:bg-secondary group-hover:text-white ${transitionClasses}`}
      >
        <p className="text-2xl font-bold">Get Started</p>
      </div>
    </Link>
  );

  const [hoverable] = useHover(element);

  return hoverable;
}
